// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2WXFk","info":"UpdateTermsInfo_info__PJVdB"};